module.exports = __webpack_public_path__ + "static/image/history/pc/202106@3x.jpg?2a2f0a96";